import { useTranslation } from "react-i18next";
import "./PreparationPage.scss";
import { useEffect, useState } from "react";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";
import Button from "../../Button/Button";
import { CheckBox } from "../../CheckBox/CheckBox";
import { Trans } from "react-i18next";

export const PreparationPage = ({ onContinue }) => {
  const { t } = useTranslation("preparationPage");
  const trackEvent = useAmplitude();
  const { uid } = useUID();

  const [isAcceptMarked, setIsAcceptMarked] = useState(false);
  const [isLicenseMarked, setIsLicenseMarked] = useState(false);
  const [isContinuePressed, setIsContinuePressed] = useState(false);

  useEffect(() => {
    trackEvent("visited_prep_page", uid);
  }, [uid, trackEvent]);

  return (
    <>
      <div className="validate-page-contents-wrapper">
        <div className="validate-content-area">
          <div className="validate-header-container">
            <h2 className="validate-title">{t("validate-title")}</h2>
            <p className="validate-sub-title">{t("validate-sub-title")}</p>
          </div>
          <div className="validate-images-container">
            <img
              className="validate-page-image"
              src="images/founder.png"
              alt="Founder"
              width={100}
            />
          </div>
        </div>
        <div
          className="licenses-wrapper"
          style={{ opacity: isContinuePressed ? 0 : 1 }}
        >
          <div className="licenses-items-wrapper">
            <div className="license-option">
              <CheckBox
                onClick={() => setIsAcceptMarked((prevValue) => !prevValue)}
              />
              <p className="validate-license-text">
                Consent to analysis for recommendations
              </p>
            </div>
            <div className="license-option">
              <CheckBox
                onClick={() => setIsLicenseMarked((prevValue) => !prevValue)}
              />
              <p className="validate-license-text">
                <Trans
                  ns="preparationPage"
                  i18nKey={"terms-text"}
                  components={{
                    click: (
                      <a
                        href="https://www.iqonicai.com/en/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="validate-license-text"
                        style={{ textDecoration: "underline" }}
                      >
                        {/* */}
                      </a>
                    ),
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="preparation-page-button-wrapper"
        style={{ opacity: isContinuePressed ? 0 : 1 }}
      >
        <Button
          text="Get Started!"
          onClick={() => {
            setIsContinuePressed(true);
            trackEvent("pressed_continue_prep_page", uid);
            setTimeout(() => onContinue(), 1000);
          }}
          disabled={!isLicenseMarked || !isAcceptMarked}
        />
      </div>
    </>
  );
};
